import { type SVGProps } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import type ZepIcon from '@/icons/ZepIcon';
import { type IconSize } from '@/icons/ZepIcon';
type TopLabelProps = {
  title?: string;
  titleLeftSlot?: React.ReactNode;
  titleRightSlot?: React.ReactNode;
  optional?: boolean;
  description?: string;
};
const TopLabelSlotIcon = ({
  icon,
  props
}: {
  icon: ReturnType<typeof ZepIcon>;
  props?: SVGProps<SVGSVGElement> & {
    size?: IconSize;
  };
}) => {
  return icon({
    size: 'xs',
    className: 'shrink-0',
    fill: ICON_COLOR.neutral,
    ...props
  });
};
const TopLabel = ({
  title,
  titleLeftSlot,
  titleRightSlot,
  optional = false,
  description
}: TopLabelProps) => {
  const {
    t
  } = useTranslation();
  return <div data-sentry-component="TopLabel" data-sentry-source-file="TopLabel.tsx">
      <div className="flex items-center gap-3xs">
        <div className="flex items-center justify-between gap-3xs">
          {titleLeftSlot}
          {title && <span className="break-words text-body-lg-bold text-default">
              {title}
            </span>}
          {titleRightSlot}
        </div>
        {optional && <span className={'shrink-0 text-caption-md-semibold text-assistive'}>
            {t('common:ui.select.optional')}
          </span>}
      </div>
      {description && <span className="inline-flex items-center break-all text-body-sm-medium text-alternative">
          {description}
        </span>}
    </div>;
};
export { TopLabel, TopLabelSlotIcon, type TopLabelProps };